import { render, staticRenderFns } from "./SubmissionHero.vue?vue&type=template&id=321e9e2d&scoped=true&"
import script from "./SubmissionHero.vue?vue&type=script&lang=js&"
export * from "./SubmissionHero.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionHero.vue?vue&type=style&index=0&id=321e9e2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321e9e2d",
  null
  
)

export default component.exports